module.exports = __webpack_public_path__ + "img/3.3b860f19.jpg";